import Modal from '../components/Modal'
import { EditorProps } from 'react-data-grid'
import { BulkBatch } from '../pages/Form/EditBatchNo'
import { FaUserLock } from 'react-icons/fa'
import { memo, useState } from 'react'
import { verifyMixingUser } from '../apis'

import { useForm, SubmitHandler } from 'react-hook-form'

interface Employee {
  username: string
  password: string
}

export default memo(function EmployeeAuthEditor({ props } : {
  props: EditorProps<BulkBatch>
}) {
  const { onClose, onRowChange, row } = props
  const [ loading, setLoading ] = useState<boolean>(false)
  const [ error, setError ] = useState<String>()
  
  const { 
    register, handleSubmit
  } = useForm<Employee>({
    defaultValues: {}
  })

  const onSubmit: SubmitHandler<Employee> = async (data) => {
    setLoading(true)
    const verified = await verifyMixingUser(data.username, data.password)
    if (verified.success) {
      setLoading(false)
      const updatedRow = { ...row, 
        approvedDatetime: Math.floor(Date.now() / 1000),
        approvedBy: verified.name || data.username
      }
      onRowChange(updatedRow, true)
    } else {
      setError(verified.message!)
      setLoading(false)
    }
  };

  return <Modal show={true} onHide={onClose}
    title='ยืนยันตัวตน พนักงาน'
    >
    <>
      <div className='flex flex-col items-center mb-3 text-center'>
        <FaUserLock size={100}/>
        <p className='text-muted'>กรอกรหัสพนักงานและรหัสผ่านที่ได้จากผู้ดูแลรบบ เพื่อยืนยันตัวตนแทนการเซ็นเอกสาร</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <small>รหัสพนักงาน</small>
        <input {...register('username', { required: true })} className='mb-3 input-form-text' type='text' placeholder='กรอกรหัสพนักงาน 6 หลัก'/>
        <small>รหัสผ่าน</small>
        <input {...register('password', { required: true })} className='mb-3 input-form-text' type='password' placeholder='กรอกรหัสผ่าน'/>
        <div className="flex w-full gap-2 mt-4">
          <button
            type="button"
            className={` btn-outline-primary basis-1/2`}
            onClick={() => onClose(false)}
          >
            ยกเลิก
          </button>
          <button
            type="submit"
            className='btn-primary basis-1/2'
          >
            {loading ? `กำลังยืนยันตัวตน...`: 'ยืนยันตัวตน'}
          </button>
        </div>
      </form>
      {error ? <small className='text-red-500'>{error}</small> : null}
    </>
  </Modal>
})